(function () {
	'use strict';

	angular.module('qbePortal').controller('qbCampaign', qbCampaign);

	qbCampaign.$inject = ['$scope', 'campaignService'];

	function qbCampaign($scope, campaignService) {
		var vm = this;
		vm.campaign = {} ; 
		vm.show = false;

		campaignService.init();
		var hasActiveCampaign = campaignService.hasActiveCampaign() ; 
		if ( hasActiveCampaign){
			try {
				var campaign = campaignService.getCampaign();
				vm.campaign = campaign ; 
				vm.show = true;
				QBE.listAccordion.init();
			} catch(ex) {
				vm.show = false ; 
				console.log('Invalid campaign: ' + ex) ; 
			}
		}	
	}

	angular.module('qbePortal').component('qbCampaign', {
		templateUrl: '/ngviews/components/qbCampaign.html',
		controller: qbCampaign,
		controllerAs: 'vm',
		bindings: {
		}
	});
})();
